export default {
  form: {
    address: {
      label: 'Adres',
      placeholder: 'Ulica i numer',
    },
    city: {
      label: 'Miasto',
      placeholder: 'Miasto',
    },
    state: {
      label: 'Stan',
      placeholder: 'Wybierz stan',
    },
    country: {
      label: 'Kraj',
      placeholder: 'Wybierz kraj',
    },
    zip_code: {
      label: 'Kod pocztowy',
      placeholder: 'Kod pocztowy',
    },
  },
};
